<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.WidthFilter.label')"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <span class="filter__summary text--disabled">
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';
import {
  WIDTH,
  WIDTH_SIZE_LABEL,
} from '@/store/modules/cards/constants';

export default {
  name: 'WidthFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    selectItems() {
      return [{
        text: WIDTH_SIZE_LABEL.SMALL,
        value: WIDTH.SMALL,
      },
      {
        text: WIDTH_SIZE_LABEL.MID,
        value: WIDTH.MID,
      },
      {
        text: WIDTH_SIZE_LABEL.LARGE,
        value: WIDTH.LARGE,
      },
      {
        text: WIDTH_SIZE_LABEL.COL5,
        value: WIDTH.COL5,
      },
      {
        text: WIDTH_SIZE_LABEL.XLARGE,
        value: WIDTH.XLARGE,
      },
      {
        text: WIDTH_SIZE_LABEL.COL7,
        value: WIDTH.COL7,
      },
      {
        text: WIDTH_SIZE_LABEL.COL8,
        value: WIDTH.COL8,
      },
      {
        text: WIDTH_SIZE_LABEL.COL9,
        value: WIDTH.COL9,
      },
      {
        text: WIDTH_SIZE_LABEL.COL10,
        value: WIDTH.COL10,
      },
      {
        text: WIDTH_SIZE_LABEL.COL11,
        value: WIDTH.COL11,
      },
      {
        text: WIDTH_SIZE_LABEL.COL12,
        value: WIDTH.COL12,
      }];
    },
  },
};

</script>

<style scoped lang="scss">
.filter__summary {
  margin-left: var(--ds-spacing-inline-nano);
}
</style>
